<template>
<v-app style="background-image: url('assets/login-bg.png'); background-size: cover">
    <!-- <Navbar /> -->
    <!-- <LeftDrawer v-if="this.$route.name !== 'login'"/>--->

    <v-main>
        <v-row>
            <v-container fluid>
               <!-- <h5 class=" grey--text text--darken-2 text-capitalize pa-4 pb-0" v-if="this.$route.name !== 'login'">{{ currentRouteName }}</h5>-->
                <router-view></router-view>
            </v-container>
        </v-row>
    </v-main>
</v-app>
</template>

<script>
// import Navbar from "./components/Navbar.vue";
import {
    mapGetters
} from 'vuex'
export default {
    name: "App",
    components: {
        // Navbar,
    },
    methods: {
        checklogin() {
            let username = localStorage.getItem('SET_USERNAME');
            if (username === null) {
                this.$router.push("/login");
            }
            //alert(username);

        }
    },
    computed: {
        currentRouteName() {
            return this.$route.fullPath.split('/').slice(1).join(' / ')
        },
        ...mapGetters(["loginusername"])
    },
    mounted() {
        this.checklogin();
    },
};
</script>
